// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2BkNc","modalForm":"UpgradeEpcsModal_modalForm__3U6dT","modalFooter":"UpgradeEpcsModal_modalFooter__16bf8"};